import React from 'react'
import { useTranslation } from 'react-i18next'

import Button from '../../../../../../../../../components/Button'
import MultipleGoogleMediaUpload from '../../MultipleGoogleMediaUpload'
import GoogleAdPreviewDiscover1 from '../../../../../../GoogleAssetsSliderPreview/Previews/GoogleAdPreviewDiscover1'

import { FILE_URL, PORTRAIT_IMAGE, portraitImageHeight, portraitImageWidth } from '../../../../../../fields'
import { portraitImageValidationSchema } from '../../../../../../validations'

import useCommonStyles from '../../../../../../../../../styles/common/stepForms'

const stepFields = [PORTRAIT_IMAGE]

function PortraitImageStep({ formik, handleStepChange, isStepFieldsValid }) {
  const commonClasses = useCommonStyles()

  const { t } = useTranslation()

  const { values } = formik

  const fileUrl = values[PORTRAIT_IMAGE][0]?.[FILE_URL]

  const handleContinue = () => {
    handleStepChange(stepFields, values)
  }

  return (
    <>
      <div className={commonClasses.stepTitle}>{t('Upload a portrait image with ratio 4:5')}</div>
      <div className={commonClasses.stepBody}>
        <GoogleAdPreviewDiscover1
          values={values}
          fileUrl={fileUrl}
          width={portraitImageWidth}
          height={portraitImageHeight}
        />
        <MultipleGoogleMediaUpload
          formik={formik}
          FileItemPath={PORTRAIT_IMAGE}
          validationSchema={portraitImageValidationSchema}
          isStepFieldsValid={isStepFieldsValid}
          addAnotherButtonText={'Add another portrait image'}
          width={portraitImageWidth}
          height={portraitImageHeight}
        />
      </div>
      <div className={commonClasses.stepFooter}>
        <Button type="button" className="dark" onClick={handleContinue}>
          {t('Continue')}
        </Button>
      </div>
    </>
  )
}

export default PortraitImageStep
